// extracted by mini-css-extract-plugin
module.exports = {"alertsMenuContainer":"Alerts_alertsMenuContainer__heLBd","alertsMenuBody":"Alerts_alertsMenuBody__3QMEh","navItem":"Alerts_navItem__29WGs"};